/**
 * A Sentry envelope: a header line, an item header line and the item, newline-separated.
 * The `length` is the item's byte length; the ingest accepts it with or without.
 */
export function serializeEnvelope(event, dsn, sentAt) {
    const body = JSON.stringify(event);
    const header = JSON.stringify({ event_id: event.event_id, sent_at: sentAt.toISOString(), dsn });
    const item = JSON.stringify({ type: 'event', length: new TextEncoder().encode(body).length });
    return `${header}\n${item}\n${body}\n`;
}
/** The `X-Sentry-Auth` header the ingest expects alongside an envelope. */
export function authHeader(publicKey, client) {
    return `Sentry sentry_version=7, sentry_client=${client}, sentry_key=${publicKey}`;
}
//# sourceMappingURL=envelope.js.map